import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { initDb } from './services/db'
import { setSoundsEnabled } from './services/sounds'
import { StoreSelectView } from './views/StoreSelectView'
import { HomeView } from './views/HomeView'
import { CategoryView } from './views/CategoryView'
import { ScannerView } from './views/ScannerView'
import { CartView } from './views/CartView'
import { PaymentView } from './views/PaymentView'
import { PaymentChangeView } from './views/PaymentChangeView'
import { ReceiptView } from './views/ReceiptView'
import { BakeryHomeView } from './views/bakery/BakeryHomeView'
import { BakeRecipeListView } from './views/bakery/BakeRecipeListView'
import { BakeRecipeView } from './views/bakery/BakeRecipeView'
import { BakeryShopView } from './views/bakery/BakeryShopView'
import { HardwareHomeView } from './views/hardware/HardwareHomeView'
import { BuildProjectListView } from './views/hardware/BuildProjectListView'
import { BuildProjectView } from './views/hardware/BuildProjectView'
import { HardwareShopView } from './views/hardware/HardwareShopView'
import { RepairTaskListView } from './views/hardware/RepairTaskListView'
import { RepairTaskView } from './views/hardware/RepairTaskView'
import { PaintView } from './views/hardware/PaintView'
import { MeasureView } from './views/hardware/MeasureView'
import { ParentLayout } from './views/parent/ParentLayout'
import { ProductListView } from './views/parent/ProductListView'
import { ProductFormView } from './views/parent/ProductFormView'
import { QRExportView } from './views/parent/QRExportView'
import { SettingsView } from './views/parent/SettingsView'
import * as db from './services/db'

const SOUND_KEY = 'soundsEnabled'

function App() {
  useEffect(() => {
    initDb().then(() => {
      db.getSetting(SOUND_KEY).then((v) => setSoundsEnabled(v !== 'false'))
    })
  }, [])

  return (
    <Routes>
      <Route path="/" element={<StoreSelectView />} />
      <Route path="/grocery" element={<HomeView />} />
      <Route path="/category/:category" element={<CategoryView />} />
      <Route path="/scan" element={<ScannerView />} />
      <Route path="/cart" element={<CartView />} />
      <Route path="/pay" element={<PaymentView />} />
      <Route path="/payment/change" element={<PaymentChangeView />} />
      <Route path="/receipt/:id" element={<ReceiptView />} />
      <Route path="/bakery" element={<BakeryHomeView />} />
      <Route path="/bakery/bake" element={<BakeRecipeListView />} />
      <Route path="/bakery/bake/:recipeId" element={<BakeRecipeView />} />
      <Route path="/bakery/shop" element={<BakeryShopView />} />
      <Route path="/hardware" element={<HardwareHomeView />} />
      <Route path="/hardware/build" element={<BuildProjectListView />} />
      <Route path="/hardware/build/:projectId" element={<BuildProjectView />} />
      <Route path="/hardware/shop" element={<HardwareShopView />} />
      <Route path="/hardware/repair" element={<RepairTaskListView />} />
      <Route path="/hardware/repair/:taskId" element={<RepairTaskView />} />
      <Route path="/hardware/paint" element={<PaintView />} />
      <Route path="/hardware/measure" element={<MeasureView />} />
      <Route path="/parent" element={<ParentLayout />}>
        <Route index element={<ProductListView />} />
        <Route path="new" element={<ProductFormView />} />
        <Route path="edit/:id" element={<ProductFormView />} />
        <Route path="qr" element={<QRExportView />} />
        <Route path="settings" element={<SettingsView />} />
      </Route>
    </Routes>
  )
}

export default App
